import React, { useEffect, useState } from "react";
import {
  Typography,
  Popover,
  withStyles,
  LinearProgress,
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
} from "@material-ui/core";
import { useListadoEtiquetas } from "../../hooks/useListadoEtiquetas";
import ChipTag from "./ChipTag";
import { useTranslation } from "react-i18next";
const styles = {
  tagInputContainer: {
    minHeight: 40,
    backgroundColor: "#f0f0f0",
    borderStyle: "solid",
    borderColor: "#e0e0e0",
    borderWidth: 1,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    maxWidth: "100%",
  },
  divider: {
    borderTopWidth: 1,
    borderColor: "#c9c9c9",
  },
  tagsListContainer: {
    width: "100%",
    padding: 6,
    backgroundColor: "white",
  },
  tagsList: {
    marginTop: 4,
    display: "flex",
    flexWrap: "wrap",
    width: "inherit",
  },
  listItem: {
    borderRadius: 5,
    padding: 4,
    "&:hover": {
      backgroundColor: "#d1d1d1",
      cursor: "pointer",
    },
  },
};

const SelectedTagsList = ({ selectedTags, classes, onDelete, t }) => {
  return (
    <>
      {!selectedTags.length && <span style={{marginLeft: 5}}>{t('tags-atentus.tags')} </span>}
      {selectedTags.map((tag) => (
        <div key={tag.etiqueta_id} className={classes.listItem}>
          <ChipTag
            etiqueta_id={tag.etiqueta_id}
            nombre={tag.nombre}
            color={tag.color}
            onDelete={onDelete ? () => onDelete(tag.etiqueta_id) : false}
          />
        </div>
      ))}
    </>
  );
};

const TagSelector = ({
  classes,
  filteredTags,
  addTag,
  handleDeleteTag,
  selectedTags,
  t,
  typeSelector
}) => {
  return (
    <div style={{ maxWidth: 670 }}>
      <div className={classes.tagInputContainer}>
        <SelectedTagsList
          selectedTags={selectedTags}
          classes={classes}
          onDelete={(value) => {
            handleDeleteTag(value);
          }}
          t={t}
        />
      </div>
      <div className={classes.divider}></div>
      {typeSelector}
      <div className={classes.divider}></div>
      <div className={classes.tagsListContainer}>
        <div style={{ padding: 4 }}>
          <Typography variant="body2" style={{ color: "#5e5e5e" }}>
            {t('tags-atentus.select-an-option')}
          </Typography>
        </div>
        <div className={classes.tagsList}>
          {filteredTags.map((tag) => (
            <div
              className={classes.listItem}
              onClick={() => addTag(tag)}
              key={tag.etiqueta_id}
            >
              <ChipTag nombre={tag.nombre} color={tag.color} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const TagsAtentus = ({
  classes,
  updateEtiquetas,
  etiquetas,
  directToPopover,
  directAnchorEl,
  tagsId,
  preload,
  filterTagsType,
  showFilterType,
}) => {
  const { t } = useTranslation();
  const [selectedTags, setSelectedTags] = useState(etiquetas);
  const [anchorEl, setAnchorEl] = useState();
  const [filterType, setFilterType] = useState(filterTagsType);
  const { data: allTags, isLoading: isLoadingTags } = useListadoEtiquetas();

  const tags = allTags.length ? allTags.filter((tag) => tag.activo) : [];

  useEffect(() => {
    if (!etiquetas.length && preload) {
      const defaultEtiquetas = tags.filter((tag) => {
        return tag.activo && tagsId.includes(tag.etiqueta_id);
      });
      setSelectedTags(defaultEtiquetas);
    }
  }, [allTags]);

  const clickEdit = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const addTag = (newTag) => {
    const newSelectedTags = [...selectedTags, newTag];
    setSelectedTags(newSelectedTags);
    updateEtiquetas(newSelectedTags, filterType);
  };

  const handleDeleteTag = (tagValue) => {
    const newSelectedTags = [...selectedTags].filter(
      (tag) => tag.etiqueta_id !== tagValue
    );
    setSelectedTags(newSelectedTags);
    updateEtiquetas(newSelectedTags, filterType);
  };

  const filteredTags = () => {
    return tags.filter((tag) => {
      return !selectedTags.some((e) => e.etiqueta_id === tag.etiqueta_id);
    });
  };

  const onClosePopover = () => {
    setAnchorEl(null);
    updateEtiquetas(selectedTags, filterType);
  };

  const handleChangeSwitchFilterType = (event) => {
    const value = event.target.value;
    setFilterType(value);
    updateEtiquetas(selectedTags, value);
  }

  return (
    <div style={{ position: "relative" }}>
      {!directToPopover ? (
        <>
          <div className={classes.tagInputContainer} onClick={clickEdit} style={{borderRadius: 4}}>
            <SelectedTagsList
              selectedTags={selectedTags}
              classes={classes}
              onDelete={false}
              t={t}
            />
            {isLoadingTags && <LinearProgress />}
          </div>
          {showFilterType &&
            <Box display="flex" alignItems="center" justifyContent="end">
              <FormControl component="fieldset">
                <RadioGroup
                  defaultValue={false}
                  aria-label="Tipo de filtro de etiquetas"
                  style={{display: "flex", flexDirection: "row"}}
                  onChange={handleChangeSwitchFilterType}
                  value={filterType}
                >
                  <Tooltip title={t('tags-atentus.tooltip.or')}>
                    <FormControlLabel value="OR" control={<Radio color="primary" />} label="OR" />
                  </Tooltip>
                  <Tooltip title={t('tags-atentus.tooltip.and')}>
                    <FormControlLabel value="AND" control={<Radio color="primary" />} label="AND" />
                  </Tooltip>
                </RadioGroup>
              </FormControl>
            </Box>
          }
          <Popover
            open={Boolean(anchorEl) || Boolean(directAnchorEl)}
            anchorEl={anchorEl || directAnchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            onClose={onClosePopover}
          >
            <TagSelector
              classes={classes}
              filteredTags={filteredTags()}
              addTag={(tag) => addTag(tag)}
              selectedTags={selectedTags}
              handleDeleteTag={(tagId) => handleDeleteTag(tagId)}
              t={t}
            />
          </Popover>
        </>
      ) : (
        <>
          <TagSelector
            classes={classes}
            filteredTags={filteredTags()}
            addTag={(tag) => addTag(tag)}
            selectedTags={selectedTags}
            handleDeleteTag={(tagId) => handleDeleteTag(tagId)}
            t={t}
            typeSelector={
              <Box sx={{backgroundColor: "white", paddingLeft: 10}}>
                <FormControl component="fieldset">
                  <RadioGroup
                    defaultValue={false}
                    aria-label="Tipo de filtro de etiquetas"
                    style={{display: "flex", flexDirection: "row"}}
                    onChange={handleChangeSwitchFilterType}
                    value={filterType}
                  >
                    <Tooltip title={t('tags-atentus.tooltip.or')}>
                      <FormControlLabel value="OR" control={<Radio color="primary" />} label="OR" />
                    </Tooltip>
                    <Tooltip title={t('tags-atentus.tooltip.and')}>
                      <FormControlLabel value="AND" control={<Radio color="primary" />} label="AND" />
                    </Tooltip>
                  </RadioGroup>
                </FormControl>
              </Box>
            }
          />
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(TagsAtentus);
